import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { toRoman, toCssClass } from 'helpers'
import { upgradeAvailability } from 'helpers/buildings'
import { BUILDING_TITLES } from 'helpers/i18n.jsx'

import UpgradeIcon from 'components/UpgradeIcon/UpgradeIcon.jsx'

import {
    BUILDING_TOOLTIP_ID,
} from 'constants'

import styles from './Building.scss'

export class Building extends React.Component {
    static propTypes = {
        building: PropTypes.object.isRequired,
        isUpgradeAvailable: PropTypes.bool.isRequired,
        reserveQueue: PropTypes.arrayOf(PropTypes.object).isRequired,
        isOwn: PropTypes.bool,

        handleClick: PropTypes.func,
        handleHover: PropTypes.func,
        buildingConstructionAnimated: PropTypes.func,
    }
    constructor(props) {
        super(props)
        this.state = { productionInProgress: false }
    }
    componentWillReceiveProps(nextProps) {
        this.processReserveQueue(nextProps.reserveQueue)
    }
    componentWillMount() {
        this.processReserveQueue(this.props.reserveQueue)
    }
    componentWillUnmount() {
        if (this.props.building.modified === true && this.props.buildingConstructionAnimated !== null) {
            this.props.buildingConstructionAnimated()
        }
        if (this.timerId) {
            clearTimeout(this.timerId)
        }
    }
    processReserveQueue(reserveQueue) {
        if (this.timerId) {
            clearTimeout(this.timerId)
        }

        const productionEnds = reserveQueue.length ? reserveQueue[reserveQueue.length - 1].productionEnds : null
        const productionInProgress = !!productionEnds && (productionEnds > Date.now())

        if (productionInProgress) {
            this.timerId = setTimeout(this.processReserveQueue.bind(this, reserveQueue), productionEnds - Date.now())
        }

        this.setState({ productionInProgress })
    }
    render() {
        const modified = (this.props.building.modified === true)
        const className = classNames(styles.base, {
            [styles.base__foreign]: !this.props.isOwn,
            [styles.base__completed]: !modified,
            [styles.base__animateCompleted]: modified,
        })

        const imageClassName = classNames(
            styles.image,
            styles[`image__${toCssClass(this.props.building.type)}`],
            styles[`image__level-${this.props.building.level}`]
        )

        const upgradeAvailable = (!this.state.productionInProgress && this.props.isUpgradeAvailable) ?
            (
                <div className={styles.upgradeAvailable}>
                    <UpgradeIcon/>
                </div>
            ) : null

        const reserveProgress = this.state.productionInProgress ?
            (
               <div className={styles.reserveProgress}/>
            ) : null

        return (
            <div
                className={className}
                onClick={this.props.handleClick}
                onMouseEnter={this.props.handleHover}
                data-tip
                data-for={`${BUILDING_TOOLTIP_ID}_${this.props.building.type}`}
            >
                <p className={styles.title}>
                    <span className={styles.level}>
                        {toRoman(this.props.building.level)}
                        <span className={styles.levelShadow}>{toRoman(this.props.building.level)}</span>
                    </span>
                    {BUILDING_TITLES[this.props.building.type]}
                </p>
                {upgradeAvailable}
                {reserveProgress}
                <div className={styles.yard}/>
                <div className={imageClassName}/>
                <div className={styles.smoke}/>
            </div>
        )
    }
}

export const mapStateToProps = (state, { building }) => {

    const reserveType = state.settings.buildings[building.type].reserve_type
    const reserveQueue = state.clanReserves[reserveType].filter((item) => (item.level === building.level))

    const isUpgradeAvailable = upgradeAvailability(state, building)

    return {
        isUpgradeAvailable,
        reserveQueue,
    }
}

export default connect(mapStateToProps, null)(Building)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/Direction/components/Building/Building.jsx